/* eslint-disable handle-callback-err */
import React from "react";
import {
  Spin,
  Form,
  Input,
  Button,
  Tabs,
  message,
  Modal,
  Select,
  Radio,
  Space,
} from "antd";
import "./login.less";
import { withRouter } from "react-router-dom";
import common from "../../public/common";
import {
  UserOutlined,
  LockOutlined,
  ExclamationCircleFilled,
  MobileOutlined,
  MailOutlined,
} from "@ant-design/icons";
import logo from "../../logo.svg";
import { axiosPost, getMethod, newAjaxApi } from "../../server/index";
import { cloneDeep, get } from "lodash";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  setCookieNew,
  md5hex,
  clearCookie,
  setCookie,
  getCookieNew,
  clearCookieNew,
} from "../../public/utils";
import ChangePassWord from "../../compenents/changepassword/changepassword";
import Axios from "axios";
import BindEmailModal from "./components/bindEmail";
import BindPhoneModal from "./components/bindPhone";
const emailReg =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const FormItem = Form.Item;
const phoneReg = /^\d{11}$/;
class NormalLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bindOpen: false,
      bindPhoneOpen: false,
      bindEmailOpen: false,
      phone_cut_count: 60,
      email_cut_count: 60,
      over90DaysInfo: {
        isNeedChangeNumber: false,
        cut_count: 60,
        initialValues: {},
        isModalOpen: false,
        waysOptions: [],
        waysSelected: "",
      },
      moreCompanysInfo: {
        options: [],
        selected: "",
        open: false,
      },
      changePasswordStatus: false,
      loading: false,
      supplierList: [],
      registerList: [],
      logindata: {},
      accountList: [],
    };
  }
  formaction = React.createRef();
  verifyFormaction = React.createRef();
  formPhoneAction = React.createRef();
  formEmailAction = React.createRef();
  componentDidMount() {
    clearCookieNew("adminName");
    clearCookieNew("userName");
    clearCookieNew("businessId");
    clearCookieNew("accountId");
    clearCookieNew("sid");
    localStorage.removeItem("accountInfo");
    window.localStorage.clear();
  }

  componentWillUnmount() {
    let { interval, intervalPhone, intervalEmail } = this.state;
    if (interval) {
      clearInterval(interval);
    }
    if (intervalPhone) {
      clearInterval(intervalPhone);
    }
    if (intervalEmail) {
      clearInterval(intervalEmail);
    }
  }

  setLoading = (val) => {
    this.setState({
      loading: val,
    });
  };
  supplierSelect = async (e, item) => {
    const res = this.state.logindata;
    const option = this.state.registerList.find(
      (e) => e.supplier_company_code == item.supplier_company_code
    );
    this.setCookiePublic(option);
    if (option.review_status == 100) {
      this.loginfunction(res);
    } else {
      this.loginOther(
        option.review_status,
        option.register_sid,
        option.request_business_id
      );
    }
  };

  setCookiePublic = (item) => {
    localStorage.setItem("accountInfo", JSON.stringify(item));
    item.register_sid && setCookieNew("sid", item.register_sid, 3);
    item.business_id && setCookieNew("businessId", item.request_business_id, 3);
    item.business_name && setCookie("business_name", item.business_name, 3);
    item.supplier_code &&
      setCookie("supplier_code", item.supplier_code || "", 3);
    item.supplier_company_code &&
      setCookie("supplier_company_code", item.supplier_company_code, 3);
    item.supplier_company_name &&
      setCookie("supplier_company_name", item.supplier_company_name, 3);
    item.po_subject_code &&
      setCookie("po_subject_code", item.po_subject_code, 3);
  };
  loginfunction = async (res) => {
    console.log(res);
    let isLoginSuccess = get(res, "data.code") == 200;
    let isEasyPwd = get(res, "data.data.scs_pwd_update") === 1;
    let user = get(res, "data.data.data.user");
    let userName = get(res, "data.data.data.userName");
    let account = get(res, "data.data.data.account");
    let isNeedBindPhoneOrEmail =
      get(res, "data.data.scs_phone_or_email_bind") === 1;
    let isBindAuthSuggestion =
      get(res, "data.data.scs_bind_auth_suggestion") === 1;
    let isOver90Days = get(res, "data.data.scs_login_overdue_check") === 1;
    let phone =
      get(res, "data.data.suggestion.phone_number") ||
      get(res, "data.data.suggestion.email");
    if (isLoginSuccess) {
      let admin = get(res, "data.data.data.account_vo");
      let mesUserEidt = {
        AccountName: get(admin, "account_name"),
        Code: get(admin, "code"),
        RealName: get(admin, "real_name"),
        UserID: get(admin, "user_id"),
        UserToken: get(admin, "user_token"),
        account: get(admin, "account_name"),
        sid: get(admin, "sid"),
        userName: get(res, "data.data.data.userName"),
      };
      setCookieNew("userName", user, 3);
      setCookieNew("adminName", encodeURI(JSON.stringify(mesUserEidt)), 3);
      if (isEasyPwd) {
        // 简单密码强制修改密码
        message.warn({
          content:
            "当前账号密码为初始密码，安全等级较低，请修改密码后再登录操作！",
          duration: 3,
        });
        this.setState({
          changePasswordStatus: true,
        });
      } else {
        // 登录成功后，判断该账号有无绑定联系方式：
        if (isOver90Days) {
          // 账号密码登录成功后，系统判断是否已超过90天，如果超过则必须追加验证码登录，进行二次验证
          let { over90DaysInfo } = this.state;
          over90DaysInfo.user = user;
          over90DaysInfo.account = account;
          // 获取验证选项
          this.setLoading(true);
          let authWaysRes = await getMethod(
            `${common.eurekaUrlDic}/auth/query-auth-way?account=${getCookieNew(
              "phone"
            )}`
          );
          this.setLoading(false);
          let phone = get(authWaysRes, "data.data.phone_number");
          let email = get(authWaysRes, "data.data.email");
          if (email || phone) {
            over90DaysInfo.isModalOpen = true;
            over90DaysInfo.phone = phone;
            over90DaysInfo.email = email;
            if (phone && email) {
              over90DaysInfo.waysOptions = [
                { value: "phone", label: "手机+验证码验证" },
                { value: "email", label: "邮箱+验证码验证" },
              ];
              over90DaysInfo.waysSelected = "phone";
              over90DaysInfo.initialValues.confirmWay = "phone";
              over90DaysInfo.initialValues.number = phone;
            } else if (phone) {
              over90DaysInfo.waysOptions = [
                { value: "phone", label: "手机+验证码验证" },
              ];
              over90DaysInfo.waysSelected = "phone";
              over90DaysInfo.initialValues.confirmWay = "phone";
              over90DaysInfo.initialValues.number = phone;
            } else if (email) {
              over90DaysInfo.waysOptions = [
                { value: "email", label: "邮箱+验证码验证" },
              ];
              over90DaysInfo.waysSelected = "email";
              over90DaysInfo.initialValues.confirmWay = "email";
              over90DaysInfo.initialValues.number = email;
            }
            this.setState(
              {
                userName,
                over90DaysInfo,
              },
              () => {
                console.log(this.state.userName);
              }
            );
          } else {
            // 90天验证，又未绑定手机号或者邮箱
            this.setLoading(false);
            this.setState({
              bindOpen: true,
            });
          }
        } else if (isNeedBindPhoneOrEmail) {
          Modal.confirm({
            title: "温馨提示",
            content: (
              <div>
                您的账号未绑定过手机号或者邮箱，安全等级较低，
                <span style={{ color: "#ffccc7" }}>
                  未保证您后续登录不会出现异常
                </span>
                ，建议立即去右上角“账号管理-安全设置”菜单进行联系信息的绑定！
              </div>
            ),
            okText: "去绑定",
            cancelText: "暂不绑定",
            onCancel: () => {
              window.location.href = common.scsWebUrl;
            },
            onOk: () => {
              window.location.href = "/main/login/setting";
            },
          });
        } else if (isBindAuthSuggestion) {
          Modal.confirm({
            title: "温馨提示",
            content: (
              <div style={{ position: "relative" }}>
                您的账号已绑定{phone ? "手机号" : "邮箱"}
                <span style={{ color: "#faad14" }}>
                  {this.hideMiddleDigits(phone)}
                </span>
                ， 若此联系方式已发生变更
                <span style={{ color: "#ffccc7" }}>
                  未保证您后续登录不会出现异常
                </span>
                ，建议立即去右上角“账号管理-安全设置”菜单进行联系信息的绑定！
                <Button
                  onClick={this.ignoreSug}
                  style={{ position: "absolute", left: 50, bottom: -56 }}
                >
                  不再提醒
                </Button>
              </div>
            ),
            okText: "去绑定",
            cancelText: "我知道了",
            onCancel: () => {
              window.location.href = common.scsWebUrl;
            },
            onOk: () => {
              window.location.href = "/main/login/setting";
            },
          });
        } else {
          window.location.href = common.scsWebUrl;
        }
      }
    }
  };
  accBaseInfoQuery = async () => {
    const res = this.state.logindata;
    console.log(res);
    let data = await newAjaxApi({
      url: common.eurekaUrlDic + "/account/base-info/query",
      params: {
        account_id: res.data.data.accountId,
      },
      ContentType: "application/json;charset=UTF-8",
    });
    console.log(data);
    if (res.status == 200) {
      this.setState({
        supplierList: data.data.account_supplier_company_list || [],
        registerList: data.data.account_enterprise_list || [],
      });
      data.data.phone && setCookieNew("phone", data.data.phone, 3);
      if (data.data.account_supplier_company_list) {
        if (data.data.account_supplier_company_list.length == 1) {
          const companyData = data.data.account_supplier_company_list[0];
          const item = data.data.account_enterprise_list.find(
            (e) => e.supplier_company_code == companyData.supplier_company_code
          );
          this.setCookiePublic(item);
          if (item.review_status == 100) {
            this.loginfunction(res);
          } else {
            this.loginOther(
              item.review_status,
              item.register_sid,
              item.request_business_id
            );
          }
        }
      } else {
        this.loginOther("201", null, "sigo");
      }
    }
  };
  //账号密码
  loginFnByPWD = async () => {
    this.formaction.current.validateFields().then(async (values) => {
      try {
        let pwdParams = {
          account: values.userName,
          password: md5hex(values.password),
          application: "scs",
          login_type: 1,
        };
        this.setLoading(true);
        let res = await this.login(pwdParams);
        this.setLoading(false);
        console.log(res);
        if (res.data.data) {
          res.data.data.accountId &&
            setCookieNew("accountId", res.data.data.accountId, 3);
          res.data.data.token &&
            setCookieNew("scs_token", res.data.data.token, 3);
          this.setState(
            {
              logindata: res,
            },
            () => {
              this.accBaseInfoQuery();
            }
          );
        }
      } catch (err) {
        console.log(err);
        this.setLoading(false);
      }
    });
  };

  login = async (params) => {
    try {
      this.setLoading(true);
      let res = await newAjaxApi({
        url: common.eurekaUrlDic + "/auth/login",
        params: params,
        ContentType: "application/json;charset=UTF-8",
        errcallback: (res) => {
          this.setLoading(false);
          let failNum = get(res, "data.data.pwd_fail_times");
          if (failNum > 1) {
            Modal.confirm({
              title: "温馨提示",
              icon: <ExclamationCircleOutlined />,
              content: `您已输入错误密码${failNum}次，再输错${
                5 - failNum
              }次将锁定账号！`,
              okText: "重新输入",
              cancelText: "找回密码",
              onCancel: () => {
                window.location.href =
                  "/main/suppliersettlement/findpassword/findpassword?opration=findpassword";
              },
            });
          }
        },
      });
      this.setLoading(false);
      return res;
    } catch (err) {
      this.setLoading(false);
    }
  };

  loginOther = (type, sid, businessId) => {
    setCookieNew("businessId", businessId || "sigo", 3);
    if (type === "101") {
      //还未填写信息，前往完善信息页面
      window.location.href =
        window.location.origin +
        "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection"
    }
    if (["201", "202", "203", "204", "205", "206", "207"].includes(type)) {
      //去基础信息填写页面
      window.location.href =
        window.location.origin +
        "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection"
    }
    if (["301", "302", "303", "304", "305"].includes(type)) {
      window.location.href =
        window.location.origin +
        "/main/suppliersettlement/compliancecertification/index?opration=perfection&&sid=" +
        sid;
    }
  };

  // 不再提醒建议
  ignoreSug = async () => {
    let res = await Axios({
      method: "get",
      url: common.eurekaUrlDic + "/auth/cancel-bind-sug",
      headers: {
        accountId: getCookieNew("accountId") || "",
        token: getCookieNew("scs_token") || "075DFE1EE73515BEC6180B8200F36265",
        Authorization:
          getCookieNew("scs_token") || "075DFE1EE73515BEC6180B8200F36265",
      },
      withCredentials: false,
    });
    if (get(res, "data.code") == 200) {
      message.success("操作成功！");
      Modal.destroyAll();
      window.location.href = common.scsWebUrl;
    }
  };

  hideMiddleDigits = (phoneNumber) => {
    if (phoneNumber) {
      const regex = /(\d{3})(\d{4})(\d{4})/;
      return phoneNumber.replace(regex, "$1****$3");
    } else {
      return "--";
    }
  };

  // 90 天验证发送验证码
  sendVFcode = () => {
    let flag = true;
    let { over90DaysInfo } = this.state;
    if (get(over90DaysInfo, "cut_count") < 60) {
      flag = false;
    }
    if (flag) {
      let number = get(this.verifyFormaction.current.getFieldValue(), "number");
      if (over90DaysInfo.waysSelected === "phone") {
        if (phoneReg.test(number)) {
          flag = true;
        } else {
          flag = false;
          this.verifyFormaction.current.setFields([
            {
              errors: ["手机号未填写或不正确"],
              name: "number",
              value: number,
            },
          ]);
        }
      } else {
        if (emailReg.test(number)) {
          flag = true;
        } else {
          flag = false;
          this.verifyFormaction.current.setFields([
            {
              errors: ["邮箱号未填写或不正确"],
              name: "number",
              value: number,
            },
          ]);
        }
      }
    }
    if (flag) {
      // 在这里加正则验证
      // 验证手机号和邮箱，不通过给于报错
      this.getVfCode(
        {
          send_id: get(this.verifyFormaction.current.getFieldValue(), "number"),
          type: 2,
          sms: over90DaysInfo.waysSelected === "phone" ? true : false,
        },
        () => {
          let interval = setInterval(() => {
            let { over90DaysInfo } = this.state;
            let cut_count = over90DaysInfo.cut_count;
            if (cut_count > 0) {
              cut_count--;
            } else {
              cut_count = 60;
              clearInterval(interval);
            }
            over90DaysInfo.cut_count = cut_count;
            this.setState({
              interval,
              over90DaysInfo,
            });
          }, 1000);
        }
      );
    }
  };

  // 90天切换验证方式
  change90VerifyWay = (value) => {
    console.log(value);
    let { over90DaysInfo } = this.state;
    over90DaysInfo.waysSelected = value;
    this.setState({
      over90DaysInfo,
    });
    let number;
    if (value === "phone") {
      number = over90DaysInfo.phone;
    } else {
      number = over90DaysInfo.email;
    }
    this.verifyFormaction.current.setFieldsValue({
      number: number,
    });
  };

  verifyModalConfirm = () => {
    this.verifyFormaction.current.validateFields().then(async (res) => {
      try {
        let { over90DaysInfo, userName } = this.state;
        let params = {
          account: getCookieNew("phone"),
          send_id: get(res, "number"),
          verify_code: get(res, "vfCode.code")
            ? get(res, "vfCode.code").trim()
            : "",
          sms: over90DaysInfo.waysSelected === "phone" ? true : false,
        };
        this.setLoading(true);
        let _res = await axiosPost(
          common.eurekaUrlDic + "/auth/check-auth",
          params
        );
        this.setLoading(false);
        if (get(_res, "data.code") === 200) {
          message.success("操作成功");
          setTimeout(() => {
            window.location.href = common.scsWebUrl;
          }, 1000);
        } else if (get(_res, "data.message")) {
          message.error(get(_res, "data.message"));
        }
      } catch (err) {
        this.setLoading(false);
      }
    });
  };

  codeLogin = (res) => {
    if (res.data.data) {
      if (res.data.data.token) {
        res.data.data.accountId &&
          setCookie("accountId", res.data.data.accountId, 3);
        res.data.data.token && setCookie("scs_token", res.data.data.token, 3);
        this.setState(
          {
            logindata: res,
          },
          () => {
            this.accBaseInfoQuery();
          }
        );
      } else {
        this.setState({
          accountList: res.data.data.data,
        });
      }
    }
  };
  // 手机登录
  loginFnByPhone = () => {
    this.formPhoneAction.current.validateFields().then(async (res) => {
      try {
        let { moreCompanysInfo } = this.state;
        let _phone = cloneDeep(get(res, "number"));
        let _vfCode = cloneDeep(get(res, "vfcode"));
        _phone = _phone ? _phone.trim() : "";
        _vfCode = _vfCode ? _vfCode.trim() : "";
        if (_phone && _vfCode) {
          this.setLoading(true);
          let res = await this.login({
            phone_number: _phone,
            verify_code: _vfCode,
            application: "scs",
            login_type: 2,
          });
          this.setLoading(false);
          console.log(res);
          this.codeLogin(res);
        }
      } catch (err) {
        this.setLoading(false);
      }
    });
  };

  // 手机登录点击获取验证码按钮
  sendVFcodeByPhone = () => {
    let flag = true;
    let { phone_cut_count } = this.state;
    let _phone = this.formPhoneAction.current.getFieldValue("number");
    let phone = _phone ? _phone.trim() : "";
    if (!/^1\d{10}$/.test(phone)) {
      flag = false;
      this.formPhoneAction.current.setFields([
        {
          errors: ["手机号未填写或不正确"],
          name: "number",
          value: _phone,
        },
      ]);
    }
    if (phone_cut_count < 60) {
      flag = false;
    }
    if (flag) {
      this.getVfCode({ send_id: phone, type: 1, sms: true }, () => {
        let { phone_cut_count } = this.state;
        let intervalPhone = setInterval(() => {
          if (phone_cut_count > 0) {
            phone_cut_count--;
          } else {
            phone_cut_count = 60;
            clearInterval(intervalPhone);
          }
          this.setState({
            intervalPhone,
            phone_cut_count,
          });
        }, 1000);
      });
    }
  };

  // 多账号登录
  confirmSelectCompany = async () => {
    try {
      let { moreCompanysInfo } = this.state;
      if (get(moreCompanysInfo, "selected")) {
        this.setLoading(true);
        let res = await axiosPost(
          common.eurekaUrlDic +
            "/auth/login-callback?req_id=" +
            moreCompanysInfo.selected,
          {}
        );
        this.setLoading(false);
        if (get(res, "data.code") == 200) {
          if (res.data.data) {
            res.data.data.sid && setCookieNew("sid", res.data.data.sid, 3);
            res.data.data.accountId &&
              setCookieNew("accountId", res.data.data.accountId, 3);
            res.data.data.businessId && setCookieNew("businessId", "sigo", 3);
            res.data.data.businessName &&
              setCookie("business_name", res.data.data.businessName, 3);
          }
          let type = get(res, "data.data.type");
          let user = get(res, "data.data.data.user");
          if (type == 100) {
            let admin = JSON.parse(
              decodeURIComponent(get(res, "data.data.data.admin"))
            );
            let mesUserEidt = {
              AccountName: get(admin, "account_name"),
              Code: get(admin, "code"),
              RealName: get(admin, "real_name"),
              UserID: get(admin, "user_id"),
              UserToken: get(admin, "user_token"),
              account: get(admin, "account_name"),
              sid: get(admin, "sid"),
              userName: get(res, "data.data.data.userName"),
            };
            setCookieNew("userName", user, 3);
            setCookieNew(
              "adminName",
              encodeURI(JSON.stringify(mesUserEidt)),
              3
            );
            window.location.href = common.scsWebUrl;
          } else {
            this.loginOther(type, get(res, "data.data.sid"), "sigo");
          }
        } else if (get(res, "data.message")) {
          message.warn(get(res, "data.message"));
        }
      } else {
        message.warn("请先选择账号");
      }
    } catch (err) {
      this.setLoading(false);
    }
  };

  // 多账号选择公司
  setSelectedCompany = (e) => {
    let { moreCompanysInfo } = this.state;
    moreCompanysInfo.selected = e.target.value;
    this.setState({
      moreCompanysInfo,
    });
  };

  // 获取验证码
  getVfCode = async (params, fn) => {
    try {
      this.setLoading(true);
      let res = await axiosPost(
        common.eurekaUrlDic + "/auth/send-verify-code",
        params
      );
      this.setLoading(false);
      if (get(res, "data.code") == 200) {
        message.success("验证码发送成功，请及时查收");
        if (fn) {
          fn();
        }
      } else {
        message.error("获取验证码失败");
      }
    } catch (err) {
      this.setLoading(false);
    }
  };

  // 邮箱登录点击获取验证码
  sendVFcodeByEmail = () => {
    let flag = true;
    let { email_cut_count } = this.state;
    let _email = this.formEmailAction.current.getFieldValue("number");
    let email = _email ? _email.trim() : "";
    if (!emailReg.test(email)) {
      flag = false;
      this.formEmailAction.current.setFields([
        {
          errors: ["邮箱未填写或不正确"],
          name: "number",
          value: email,
        },
      ]);
    }
    if (email_cut_count < 60) {
      flag = false;
    }
    if (flag) {
      this.getVfCode({ send_id: email, type: 1, sms: false }, () => {
        let { email_cut_count } = this.state;
        let intervalEmail = setInterval(() => {
          if (email_cut_count > 0) {
            email_cut_count--;
          } else {
            email_cut_count = 60;
            clearInterval(intervalEmail);
          }
          this.setState({
            intervalEmail,
            email_cut_count,
          });
        }, 1000);
      });
    }
  };

  // 邮箱登录
  loginFnByEmail = () => {
    this.formEmailAction.current.validateFields().then(async (res) => {
      let { moreCompanysInfo } = this.state;
      let _email = cloneDeep(get(res, "number"));
      let _vfCode = cloneDeep(get(res, "vfcode"));
      _email = _email ? _email.trim() : "";
      _vfCode = _vfCode ? _vfCode.trim() : "";
      if (_email && _vfCode) {
        let res = await this.login({
          email: _email,
          verify_code: _vfCode,
          application: "scs",
          login_type: 3,
        });
        console.log(res);
        this.codeLogin(res);
      }
    });
  };

  render() {
    let {
      over90DaysInfo,
      phone_cut_count,
      moreCompanysInfo,
      email_cut_count,
      supplierList,
      accountList,
    } = this.state;
    return (
      <div className="login-body">
        <div className="login-page">
          <div className="login-header">
            <img src={logo} alt="logo" className="login-logo" />
            <span className="login-title">供应商协同系统</span>
          </div>
          <div>
            <Spin spinning={this.state.loading}>
              {supplierList.length <= 1 && accountList.length <= 1 && (
                <Tabs defaultActiveKey="2" tabBarGutter={90}>
                  <Tabs.TabPane tab="手机登录" key="2">
                    <Form ref={this.formPhoneAction} className="login-form">
                      <Input.Group
                        compact
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Item rules={[{ required: false }]}>
                          <Select
                            size="large"
                            style={{ width: 140 }}
                            disabled={true}
                            defaultValue={"+86"}
                            options={[{ value: "+86", label: "中国大陆+86" }]}
                          />
                        </Form.Item>
                        <Form.Item
                          name={"number"}
                          rules={[
                            { required: true, message: "请输入11位手机号" },
                          ]}
                        >
                          <Input
                            placeholder="请输入11位手机号"
                            maxLength={11}
                            style={{ width: 260 }}
                            size="large"
                            prefix={<MobileOutlined style={{ fontSize: 13 }} />}
                          />
                        </Form.Item>
                      </Input.Group>
                      <Input.Group
                        compact
                        style={{
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <Form.Item
                          name={"vfcode"}
                          rules={[{ required: true, message: "请输入验证码" }]}
                        >
                          <Input
                            style={{ width: 400 }}
                            size="large"
                            maxLength={6}
                            placeholder="请输入验证码"
                            prefix={<MailOutlined style={{ fontSize: 13 }} />}
                          />
                        </Form.Item>
                        <Form.Item>
                          <Button
                            onClick={this.sendVFcodeByPhone}
                            disabled={phone_cut_count < 60}
                            size="large"
                            type="link"
                            style={{
                              position: "absolute",
                              right: 0,
                              top: -5,
                              zIndex: 9,
                            }}
                          >
                            {phone_cut_count < 60
                              ? `${phone_cut_count}s`
                              : "获取验证码"}
                          </Button>
                        </Form.Item>
                      </Input.Group>
                      <FormItem>
                        {" "}
                        <Button
                          type="primary"
                          onClick={this.loginFnByPhone}
                          size="large"
                          className="loginButton"
                        >
                          登录
                        </Button>
                      </FormItem>
                      <FormItem>
                        <div style={{ textAlign: "right" }}>
                          <a
                            href={
                              "/main/suppliersettlement/supplierregistration/supplierregistration?opration=register"
                            }
                          >
                            新供应商注册
                          </a>
                        </div>
                      </FormItem>
                    </Form>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="邮箱登录" key="3">
                    <Form ref={this.formEmailAction} className="login-form">
                      <Form.Item
                        name={"number"}
                        rules={[{ required: true, message: "请输入邮箱" }]}
                      >
                        <Input
                          placeholder="请输入邮箱"
                          style={{ width: 400 }}
                          size="large"
                          prefix={<MailOutlined style={{ fontSize: 13 }} />}
                        />
                      </Form.Item>
                      <Input.Group
                        compact
                        style={{
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <Form.Item
                          name={"vfcode"}
                          rules={[{ required: true, message: "请输入验证码" }]}
                        >
                          <Input
                            maxLength={6}
                            style={{ width: 400 }}
                            size="large"
                            placeholder="请输入验证码"
                            prefix={<MailOutlined style={{ fontSize: 13 }} />}
                          />
                        </Form.Item>
                        <Form.Item>
                          <Button
                            onClick={this.sendVFcodeByEmail}
                            disabled={email_cut_count < 60}
                            size="large"
                            type="link"
                            style={{
                              position: "absolute",
                              right: 0,
                              top: -5,
                              zIndex: 9,
                            }}
                          >
                            {email_cut_count < 60
                              ? `${email_cut_count}s`
                              : "获取验证码"}
                          </Button>
                        </Form.Item>
                      </Input.Group>
                      <Form.Item>
                        <Button
                          type="primary"
                          onClick={this.loginFnByEmail}
                          size="large"
                          className="loginButton"
                        >
                          登录
                        </Button>
                      </Form.Item>
                      <FormItem>
                        <div style={{ textAlign: "right" }}>
                          <a
                            href={
                              "/main/suppliersettlement/supplierregistration/supplierregistration?opration=register"
                            }
                          >
                            新供应商注册
                          </a>
                        </div>
                      </FormItem>
                    </Form>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="账号密码登录" key="1">
                    <Form ref={this.formaction} className="login-form">
                      <FormItem
                        rules={[
                          { required: true, message: "请输入供应商账号!" },
                        ]}
                        name="userName"
                      >
                        <Input
                          prefix={<UserOutlined style={{ fontSize: 13 }} />}
                          placeholder="请输入供应商账号"
                          size="large"
                        />
                      </FormItem>
                      <FormItem
                        rules={[{ required: true, message: "请输入登录密码!" }]}
                        name="password"
                      >
                        <Input
                          prefix={<LockOutlined style={{ fontSize: 13 }} />}
                          type="password"
                          placeholder="请输入登录密码"
                          size="large"
                        />
                      </FormItem>
                      <FormItem style={{ marginBottom: "8px" }}>
                        <Button
                          type="primary"
                          onClick={this.loginFnByPWD}
                          size="large"
                          className="loginButton"
                        >
                          登录
                        </Button>
                      </FormItem>
                      <FormItem>
                        <a
                          style={{ color: "#000000a6", float: "left" }}
                          href="/main/suppliersettlement/findpassword/findpassword?opration=findpassword"
                        >
                          忘记密码？
                        </a>{" "}
                        <div style={{ textAlign: "right" }}>
                          <a
                            href={
                              "/main/suppliersettlement/supplierregistration/supplierregistration?opration=register"
                            }
                          >
                            新供应商注册
                          </a>
                        </div>
                      </FormItem>
                    </Form>
                  </Tabs.TabPane>
                </Tabs>
              )}
              {supplierList.length > 1 && (
                <Select
                  style={{ width: 350 }}
                  placeholder="请选择需要登录的主体"
                  allowClear
                  options={supplierList}
                  fieldNames={{
                    label: "supplier_company_name",
                    value: "supplier_company_code",
                  }}
                  onSelect={(e, option) => {
                    this.supplierSelect(e, option);
                  }}
                />
              )}
              {accountList.length > 1 && supplierList.length == 0 && (
                <Select
                  style={{ width: 350 }}
                  placeholder="请选择需要登录的供应商"
                  allowClear
                  options={accountList}
                  fieldNames={{
                    label: "realName",
                    value: "account",
                  }}
                  onSelect={async (e, option) => {
                    console.log(option);
                    option.accountId &&
                      setCookieNew("accountId", option.accountId, 3);
                    option.token && setCookieNew("scs_token", option.token, 3);
                    let res = await newAjaxApi({
                      url: common.eurekaUrlDic + "/auth/account-login/add",
                      params: {
                        ...option,
                      },
                      ContentType: "application/json;charset=UTF-8",
                    });
                    if (res.data.code == 200) {
                      this.setState(
                        {
                          logindata: {
                            status: 200,
                            data: {
                              code: 200,
                              data: option,
                            },
                          },
                        },
                        () => {
                          this.accBaseInfoQuery();
                        }
                      );
                    }
                  }}
                />
              )}
            </Spin>
          </div>
        </div>
        <ChangePassWord
          changePasswordStatus={this.state.changePasswordStatus}
        />
        {/* 90 天超期验证 */}
        <Modal
          width={600}
          title="验证码验证"
          onOk={this.verifyModalConfirm}
          onCancel={() => {
            window.location.reload();
          }}
          open={get(over90DaysInfo, "isModalOpen")}
        >
          <div>
            <div className="mb12">
              <ExclamationCircleFilled
                style={{ color: "#faad14", marginRight: 4 }}
              />
              <span>当前账号</span>
              <span style={{ color: "orange" }}>
                {get(over90DaysInfo, "user")}
                {get(over90DaysInfo, "account")}
              </span>
              <span>为确认是你本人操作，请完成以下验证！</span>
            </div>
            <Form
              initialValues={get(over90DaysInfo, "initialValues")}
              ref={this.verifyFormaction}
              wrapperCol={{ span: 16 }}
            >
              <Form.Item
                label="验证方式"
                rules={[{ required: true, message: "请选择验证方式!" }]}
                name="confirmWay"
              >
                <Select
                  onChange={this.change90VerifyWay}
                  style={{ width: 252 }}
                  options={get(over90DaysInfo, "waysOptions")}
                />
              </Form.Item>
              <Space>
                <Form.Item
                  label={
                    get(over90DaysInfo, "waysSelected") === "phone" ? (
                      "手机号码"
                    ) : (
                      <span style={{ marginLeft: 40 }}>邮箱</span>
                    )
                  }
                >
                  <Form.Item
                    name="number"
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: `请输入${
                          get(over90DaysInfo, "waysSelected") === "phone"
                            ? "手机号码"
                            : "邮箱"
                        }`,
                      },
                    ]}
                  >
                    <Input
                      disabled={!get(over90DaysInfo, "isNeedChangeNumber")}
                      style={{ width: 252 }}
                      placeholder="请输入验证号码"
                    />
                  </Form.Item>
                  {/* <Button onClick={() => { let { over90DaysInfo } = this.state; over90DaysInfo.isNeedChangeNumber = true; this.setState({ over90DaysInfo, }) }} type='link'>点击换绑</Button> */}
                </Form.Item>
                <span
                  style={{
                    color: "orange",
                    fontSize: 13,
                    display: "inline-block",
                    height: 40,
                  }}
                >
                  若需要换绑，请联系视客采购人员！
                </span>
              </Space>
              <Form.Item label={<span style={{ marginLeft: 30 }}>验证码</span>}>
                <Space siz={0}>
                  <Form.Item
                    noStyle
                    rules={[{ required: true, message: "请输入验证码" }]}
                    name={[`vfCode`, "code"]}
                  >
                    <Input style={{ width: 150 }} placeholder="请输入验证码" />
                  </Form.Item>
                  <Button
                    disabled={get(over90DaysInfo, "cut_count") < 60}
                    style={{ width: 102 }}
                    onClick={this.sendVFcode}
                    type="primary"
                  >
                    {get(over90DaysInfo, "cut_count") < 60
                      ? `${get(over90DaysInfo, "cut_count")}s`
                      : "获取验证码"}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
        </Modal>
        {/* 多账号选择 */}
        <Modal
          width={500}
          open={get(moreCompanysInfo, "open")}
          title="选择账号"
          onOk={this.confirmSelectCompany}
          onCancel={() => {
            this.setState({
              moreCompanysInfo: { options: [], selected: "", open: false },
            });
          }}
        >
          <div>
            <div className="mb24">
              <ExclamationCircleFilled
                style={{ color: "#faad14", marginRight: 4 }}
              />
              <span>
                您输入的联系方式绑定了多个账号，请自行选择登录哪个账号
              </span>
            </div>
            <Radio.Group
              onChange={this.setSelectedCompany}
              value={get(moreCompanysInfo, "selected")}
            >
              <Space direction="vertical">
                {get(moreCompanysInfo, "options.length") > 0 &&
                  moreCompanysInfo.options.map((item, index) => {
                    return (
                      <Radio key={index} value={item.reqId}>
                        {item.account}
                      </Radio>
                    );
                  })}
              </Space>
            </Radio.Group>
          </div>
        </Modal>
        <Modal
          width={500}
          maskClosable={false}
          closable={false}
          open={this.state.bindOpen}
          title="温馨提示"
          footer={null}
          onOk={this.confirmSelectCompany}
          onCancel={() => {
            this.setState({
              moreCompanysInfo: { options: [], selected: "", open: false },
            });
          }}
        >
          <div>
            <div className="mb24">
              <ExclamationCircleFilled
                style={{ color: "#faad14", marginRight: 4 }}
              />
              <span>
                您的账号未绑定过手机号或者邮箱，安全等级较低，请立即进行绑定！
              </span>
            </div>
            <div>
              <Space
                style={{ display: "flex", justifyContent: "space-evenly" }}
              >
                <Button
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  退出系统
                </Button>
                <Button
                  onClick={() => {
                    this.setState({ bindPhoneOpen: true });
                  }}
                  type="primary"
                >
                  绑定手机号
                </Button>
                <Button
                  onClick={() => {
                    this.setState({ bindEmailOpen: true });
                  }}
                  type="primary"
                >
                  绑定邮箱
                </Button>
              </Space>
            </div>
          </div>
        </Modal>
        <BindEmailModal
          onCancel={() => {
            this.setState({ bindEmailOpen: false });
          }}
          open={this.state.bindEmailOpen}
        />
        <BindPhoneModal
          onCancel={() => {
            this.setState({ bindPhoneOpen: false });
          }}
          open={this.state.bindPhoneOpen}
        />
      </div>
    );
  }
}

class Login extends React.Component {
  render() {
    return <NormalLoginForm />;
  }
}
export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/pages/login/login.js